import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import * as RestService from '../../services/eisRest';
import DocumentWorkOrderListTab  from '../../modules/workOrder/DocumentWorkOrderListTab';
import DocumentWorkOrderTab  from '../../modules/workOrder/DocumentWorkOrderTab';



const DocumentWorkOrder = (props) => {

    const [activeTab, setActiveTab] = useState('LIST');
    const [t] = useTranslation();
    //const [workOrder, setWorkOrderDocument] = useState();
    const [selectedRecord, setSelectedRecord] = useState();   
    const [checkTime, setCheckTime] = useState();
    

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

  

    const handleLoadedDocument = (workOrder) => {
       // setWorkOrderDocument(workOrder);
        setCheckTime(Date.now());
    }

    const handleDocumentSelected = (id,newDoc) => {
        
          

        RestService.callAnyApi('workOrder/getWorkOrder?id='+id, null)
                    .then((data) => {
                      //  setWorkOrderDocument(data);   
                         if(data.id!=null && data.id!==''){
                            setSelectedRecord(id);
                            setActiveTab('DOCUMENT');                            
                         }else{
                            setSelectedRecord(Date.now());
                            if(newDoc){
                                setActiveTab('DOCUMENT');  
                            }
                         }
                        
                    })
                    .catch((error) => {    
                      toast.error(error);
                    });                  
    }

    return (
        <>
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1>{t('workOrder.label.workOrder')}</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/">{t('workOrder.label.workOrder')}</Link>
                                </li>
                                <li className="breadcrumb-item active">
                                    {t('workOrder.label.workOrder')}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <div className="row"></div>
                            <div className="col-12 col-sm-12 col-lg-12" style={{margin: '0 auto',float: 'none'}}>
                                <div className="card card-primary card-outline card-tabs">
                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                        <ul className="nav nav-tabs" role="tablist">
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'LIST'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        {
                                                            toggle('LIST');                                                                                                                        
                                                        }
                                                    }
                                                >
                                                    {t('document.label.list')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'DOCUMENT'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('DOCUMENT')
                                                    }
                                                >
                                                    {t('document.label.document')}
                                                </button>
                                            </li>                                                                                     
                                        </ul>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content">
                                            <DocumentWorkOrderListTab                                             
                                                isActive={activeTab === 'LIST'}  
                                                parentCallback={handleDocumentSelected}
                                                checkTime={checkTime}      
                                            />                                                                                                                                                                           
                                            <DocumentWorkOrderTab                                            
                                                isActive={activeTab === 'DOCUMENT'}  
                                                selectedRecord={selectedRecord}
                                                parentCallback={handleLoadedDocument}
                                            />                                                                                                                                                                
                                        </div>
                                    </div>
                                </div>   
                            </div>                         
                </div>
            </section>
        </>
    );
};

export default DocumentWorkOrder;